import React from 'react';
import { useForm, Controller } from 'react-hook-form';

import useAuth from "../hooks/useAuth.ts";
import '../../style/login.css';
import { Grid, TextField, ThemeProvider } from '@mui/material';
import { darkTheme } from '../utils/graphUtils.tsx';
import {useNavigate} from "react-router-dom";

type LoginForm = {
    username: string;
    password: string;
};

export default function Login() {
    const { login } = useAuth();
    const [ error, setError ] = React.useState<string | null>(null);
    const navigate = useNavigate(); // Initialize the navigate function from React Router
    const { control, handleSubmit } = useForm<LoginForm>({ defaultValues: { username: '', password: '' } });

    const onSubmit = async (data: LoginForm) => {
        setError(null);
        try {
            await login(data.username, data.password);
            navigate('/dashboards');
        } catch (err: any) {
            if(err.message === 'Popup closed')
                setError("Login fallito");
            else if(err.message === 'Errore di certificato')
                setError("Insights momentaneamente non disponibile");
            else if(err.message === 'Credenziali non valide')
                setError("Username o password non validi");
            else
                setError("Login fallito");
        }
    };

    return (
        <ThemeProvider theme={darkTheme}>
            <Grid container direction="row" className='login-container'
                    sx={{ justifyContent: "center", alignItems: "center"}}>
                <Grid item container direction="column" className='login-box'
                    sx={{ justifyContent: "center", alignItems: "center", rowGap:'30px'}}
                    component="form"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <Grid item container direction="row" gap={'30px'}
                        sx={{ justifyContent: "center", alignItems: "center" }}
                    >
                        <img src={`${process.env.PUBLIC_URL}/images/RTL_logo.svg`} alt="logo" className="dashboard-image" />
                        <span className="dashboard-text">Insight Dashboards</span>
                    </Grid>

                    <Grid item container direction="column" gap={'15px'} sx={{ width: '100%' }}>
                        <Controller
                            name="username"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                                <TextField {...field} label="Username" variant="outlined" fullWidth autoFocus />
                            )}
                        />
                        <Controller
                            name="password"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                                <TextField {...field} label="Password" type="password" variant="outlined" fullWidth />
                            )}
                        />
                    </Grid>

                    <button className="button-query login-button" type="submit" title="Accedi">Accedi</button>

                    {error && <span className="error-message" style={{fontSize: '20px'}}><span>{error}</span></span>}

                </Grid>
            </Grid>
        </ThemeProvider>
    );
}
